import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Upload, CheckSquare, Play, Eye, ListChecks, ChevronRight } from 'lucide-react';
import { clsx } from 'clsx';
import { api } from '../../lib/api';

const TYPE_ICONS: Record<string, React.ReactNode> = {
  upload_document: <Upload className="h-5 w-5 text-blue-500" />,
  verify_facts: <CheckSquare className="h-5 w-5 text-orange-500" />,
  run_agent: <Play className="h-5 w-5 text-green-500" />,
  review_finding: <Eye className="h-5 w-5 text-purple-500" />,
  start_plan: <ListChecks className="h-5 w-5 text-indigo-500" />,
  complete_step: <CheckSquare className="h-5 w-5 text-teal-500" />,
};

export function NextActions() {
  const { data } = useQuery({
    queryKey: ['nextActions'],
    queryFn: () => api.getNextActions(),
  });

  const actions = data?.actions ?? [];
  if (actions.length === 0) return null;

  return (
    <div className="bg-white rounded-lg border">
      <div className="px-4 py-3 border-b">
        <h3 className="text-sm font-semibold text-gray-700">Next Steps</h3>
      </div>
      <div className="divide-y divide-gray-100">
        {actions.map((action: any, i: number) => (
          <Link
            key={action.id}
            to={action.targetUrl}
            className={clsx(
              'flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors',
              i === 0 && 'bg-blue-50/50'
            )}
          >
            <div className="flex-shrink-0">
              {TYPE_ICONS[action.type] ?? <ChevronRight className="h-5 w-5 text-gray-400" />}
            </div>
            <div className="flex-1 min-w-0">
              <p className={clsx('text-sm font-medium', i === 0 ? 'text-gray-900' : 'text-gray-700')}>
                {action.title}
              </p>
              <p className="text-xs text-gray-500 truncate">{action.description}</p>
            </div>
            <ChevronRight className="h-4 w-4 text-gray-400 flex-shrink-0" />
          </Link>
        ))}
      </div>
    </div>
  );
}
